// extracted by mini-css-extract-plugin
export default {"changePasswordForm":"ChangePasswordForm_changePasswordForm__emFxv","input":"ChangePasswordForm_input__qwgy4"};